import { useI18n } from 'vue-i18n'
import { useDonorPlan } from '@/composables/useDonorPlan'
import type { SwiftaidGivingPlan } from '@/types/swiftaidGiving'

/**
 * Resolves i18n keys that vary by Swiftaid Giving plan (`free` | `paid`).
 * Expects messages nested as `{ baseKey: { free: '...', paid: '...' } }`.
 */
export function usePlanI18n() {
  const { t } = useI18n()
  const { plan } = useDonorPlan()

  const planT = (
    baseKey: string,
    params?: Record<string, string | number>
  ): string => t(`${baseKey}.${plan.value as SwiftaidGivingPlan}`, params ?? {})

  return { planT, plan }
}
